export const PACKAGE_VERSION = '2.4.0'
